import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import container from 'src/container';
import { getPrimaryRole, isUserAdmin, UserRole } from 'src/domain/user';
import { supportModeService } from 'src/services/supportMode.service';
import { useSignedInUser } from './useSignedInUser';
import { useCurrentOrganizationId } from './useCurrentOrganizationId';

export const ForegroundActivity = () => {
    const user = useSignedInUser();
    const organizationId = useCurrentOrganizationId();
    const { pathname } = useLocation();
    const role = getPrimaryRole(user);
    const enabled =
        !!user &&
        !!organizationId &&
        !isUserAdmin(user) &&
        [UserRole.creator, UserRole.nextOfKin].includes(role as UserRole) &&
        pathname.startsWith('/app');
    useEffect(() => {
        if (!enabled || !organizationId) return;
        let lastSent = -Infinity;
        let pending = false;
        let disposed = false;
        const signal = () => {
            if (
                disposed ||
                pending ||
                supportModeService.get() ||
                document.visibilityState !== 'visible' ||
                !document.hasFocus() ||
                Date.now() - lastSent < 5 * 60_000
            )
                return;
            pending = true;
            void container.cradle.munduClient
                .recordForegroundActivity(organizationId)
                .then(() => {
                    lastSent = Date.now();
                })
                .catch(() => {
                    lastSent = Date.now() - 4 * 60_000;
                })
                .finally(() => {
                    pending = false;
                });
        };
        signal();
        const timer = window.setInterval(signal, 60_000);
        document.addEventListener('visibilitychange', signal);
        window.addEventListener('focus', signal);
        return () => {
            disposed = true;
            window.clearInterval(timer);
            document.removeEventListener('visibilitychange', signal);
            window.removeEventListener('focus', signal);
        };
    }, [enabled, organizationId, user?.id]);
    return null;
};
